<script setup lang="ts">
import { getEnvVar } from '@/utils/env';

const BASE_URL = getEnvVar('VITE_CDN_BASE_URL');
const loadingIcon = `${BASE_URL}/assets/images/loading.png`;
</script>
<template>
  <div class="loading-spinner">
    <div class="vacv-loader">
      <img :alt="$t('common.generic.loading')" :src="loadingIcon" />
    </div>
  </div>
</template>
